<template lang="pug">
.container.grid-lg
  form.columns.align-center(@submit.prevent='search()')
    .pb-1.column.col-auto
      small {{ 'ordem_servico.numero' | tModel }}
      int.form-input.input-sm(v-model='q.numero_eq')
    .pb-1.column.col-auto
      small {{ 'ordem_servico.ano' | tModel }}
      year.form-input.input-sm(v-model='q.ano_eq')
    .pb-1.column.col-auto
      small {{ 'ordem_servico.cadastro' | tModel }}
      cadastro-picker(v-model="q.cadastro_id_eq" sm)
    .pb-1.column.col-auto
      small Data início
      datepicker(v-model='q.created_at_gteq' input-class='form-input input-sm')
    .pb-1.column.col-auto
      small Data fim
      datepicker(v-model='q.created_at_lteq' input-class='form-input input-sm')
    .pb-1.column.col-auto
      small &nbsp;
      div
        button.btn.btn-link.tooltip.tooltip-bottom(type='submit' data-tooltip='Pesquisar')
          btn-icon.fa-lg(name='search')
        router-link.btn.btn-link.tooltip.tooltip-bottom(:to="{name: 'app.osm.compartilhado.assuntos'}" data-tooltip='Nova OS-m')
          i.icon.icon-plus

  load-manager(:status='status')
    list-manager(:status='status', :count='list.length')
      table.text-small.table.table-striped.table-responsive.table-hover.table-xs
        thead
          tr
            th {{ 'ordem_servico.numero' | tModel }}
            th {{ 'ordem_servico.assunto' | tModel }}
            th {{ 'ordem_servico.cadastro' | tModel }}
            th {{ 'ordem_servico.created_at' | tModel }}
            th {{ 'ordem_servico.situacao' | tModel }}
            th.text-right(width="1")
        tbody
          tr(v-for="servico in list" :key="servico.id")
            td {{ servico.numero }}/{{ servico.ano }}
            td
              div {{ deepKey(servico, 'assunto.descricao') }}
              div {{ deepKey(servico, 'assunto.departamento.diretoria.secretaria.sigla') }}
                span.abbr  - {{ deepKey(servico, 'assunto.departamento.nome') }}
            td {{ servico.cadastro ? servico.cadastro.numero : '-' }}
            td {{ servico.created_at | date }}
            td {{ servico | enums('ordem_servico.situacao') }}
            td.text-right
              router-link.btn.btn-link.tooltip.tooltip-left(
                data-tooltip="Exibir"
                :to="{name: 'app.osm.compartilhado.servicos.show', params: {id: servico.id}}"
              )
                i.fa.fa-eye
    .my-2.text-right(v-if='pages > 1')
      btn-paginate(:page='page', :pages='pages', :count='count', @go-page='goPage', @prev-page='prevPage', @next-page='nextPage')
</template>

<script>
import listMixin, { vuexDefaultMapping } from '@/mixins/list'
import { deepKey } from 'paliari-js-utils'

export default {
  vuex: {
    'compartilhado/servicos': vuexDefaultMapping,
  },

  mixins: [listMixin],

  methods: {
    deepKey,
  },

  data() {
    return {
      q: {
        id_order_by: 'desc',
      },
    }
  },

  created() {
    this.q = { ...this.q, ...this.query }
    this.setQuery(this.q)
    if (!this.list || this.list.length === 0) {
      this.search()
    }
  },
}
</script>
